import { all, takeLatest, put, call, select } from 'redux-saga/effects';

import { apiResendPhoneSignupVerification } from '@dragonfruit/services/apis';
import { showAlertBanner } from '@dragonfruit/redux/alertBanner';
import {
  getSignupCountryCode,
  getSignupPhoneNumber,
} from '@dragonfruit/redux/signup';
import {
  RESEND_PHONE_VERIFICATION,
  resendPhoneVerificationSuccess,
  resendPhoneVerificationError,
} from '@dragonfruit/redux/resendPhoneVerification';
import {
  ALERT_ERROR_THEME,
  ALERT_SUCCESS_THEME,
} from '@dragonfruit/constants/alertBannerThemes';

export function* resendPhoneVerificationFlow() {
  try {
    const countryCode = yield select(getSignupCountryCode);
    const phoneNumber = yield select(getSignupPhoneNumber);

    // don't need any response from this API
    yield call(apiResendPhoneSignupVerification, {
      countryCode,
      phoneNumber,
    });
    yield put(resendPhoneVerificationSuccess());
    yield put(
      showAlertBanner({
        message: 'onboarding:onboarding.setUp.phoneNumber.sendAlertBanner',
        theme: ALERT_SUCCESS_THEME,
      })
    );
  } catch (err) {
    yield put(resendPhoneVerificationError(err.message));
    showAlertBanner({
      message: 'error:error.someThingWrong',
      theme: ALERT_ERROR_THEME,
    });
  }
}

export default function*() {
  yield all([
    takeLatest(RESEND_PHONE_VERIFICATION, resendPhoneVerificationFlow),
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/resendPhoneVerification.js